<template>
  <b-table
    id="request-table"
    :busy.sync="loadingRequests"
    :current-page="currentPage"
    :fields="fields"
    :items="requests"
    :per-page="perPage"
    bordered
    borderless
    class="table-row-text my-team-striped"
    empty-text="There are no data to show."
    hover
    primary-key="Id"
    responsive
    show-empty
    stacked="sm"
    striped
    thead-class="thMyTeam"
  >
    <template #table-caption></template>
    <template #table-busy>
      <div class="text-center text-secondary my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Loading...</strong>
      </div>
    </template>
    <template v-slot:head()="data">
      <div class="my-team-table-header text-nowrap">
        {{ data.label }}
      </div>
    </template>
    <template #cell(studyID)="row">
      {{ row.item['studyID'] }} - {{ row.item['siteNumber'] }}
    </template>
    <template #cell(systemRole)="row">
      <div v-if="row.item['systemRole'] !== 'Null'">{{ row.item['systemRole'] }}</div>
    </template>
    <template #cell(lastUpdated)="row"> {{ formatDate(row.item['lastUpdated']) }}</template>
    <template #cell(statusMap)="row">
      <div class="inline-block">
        <new-status-map :status="row.item['statusMap']" :pendingReason="row.item['pendingReason']">
          <template #pendingReason>
            <b-icon
              v-if="row.item['pendingReason'] && row.item['status'] === 'PENDING'"
              :id="row.item['salesforceChildID']"
              v-b-popover.hover.html.top="popoverContent(row.item['pendingReason'])"
              class="ml-2"
              icon="info-circle-fill"
              scale="1"
              variant="info"
            ></b-icon>
          </template>
        </new-status-map>
      </div>
    </template>
    <template #cell(accountStatus)="row">
      <status :status="row.item['accountStatus']"></status>
    </template>
    <template #cell(on_behalf_of_user)="row">
      <div>
        <strong>{{ getFullName(row.item) }}</strong>
        <!-- <p>{{ row.item['useremailAddress'] }}</p> -->
      </div>
    </template>
    <template #cell(requester)="row">
      <div>
        <strong>{{ row.item.requestorFirstName + ' ' + row.item.requestorLastName }}</strong>
        <!-- <p>{{ row.item['requestorEmailID'] }}</p> -->
      </div>
    </template>
  </b-table>
</template>

<script>
  import Status from '../../../common/Status';
  import NewStatusMap from '../../../common/NewStatusMap';
  import moment from 'moment';

  export default {
    name: 'children-requests-table',
    components: {
      Status,
      NewStatusMap,
    },
    props: {
      loadingRequests: Boolean,
      currentPage: Number,
      perPage: Number,
      requests: Array,
    },
    data() {
      return {
        fields: [
          {
            key: 'childId',
            label: 'Request ID',
          },
          {
            key: 'studyID',
            label: 'Study ID - Site #',
            sortable: true,
          },
          {
            key: 'on_behalf_of_user',
            label: 'Requested For',
          },
          {
            key: 'requester',
            label: 'Requested By',
          },
          {
            key: 'application',
            label: 'Application',
            sortable: true,
          },
          {
            key: 'systemRole',
            label: 'Application Role',
          },

          {
            key: 'statusMap',
            label: 'Request Status',
            sortable: true,
          },
          {
            key: 'accountStatus',
            label: 'Account Status',
            sortable: true,
          },
          {
            key: 'lastUpdated',
            label: 'Last Updated Date',
            sortable: true,
          },
        ],
      };
    },
    methods: {
      getFullName(user) {
        return user['userfirstName'] + ' ' + user['userlastName'];
      },
      formatDate(date) {
        if (date) {
          return moment(date).format('DD MMM YYYY');
        }
      },
      popoverContent(pendingReason) {
        return {
          html: true,
          title: 'Pending Reason',
          content:
            pendingReason !== null ? pendingReason : 'No pending reason found for this request.',
        };
      },
    },
  };
</script>
